"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
var is_array_1 = require("./is-array");
var is_nil_1 = require("./is-nil");
exports.default = (function (data, name) {
    var rst = [];
    var tmpMap = {};
    data.forEach(function (obj) {
        var value = obj[name];
        if (!is_nil_1.default(value)) {
            // flatten
            if (!is_array_1.default(value)) {
                value = [value];
            }
            each_1.default(value, function (val) {
                // unique
                if (!tmpMap[val]) {
                    rst.push(val);
                    tmpMap[val] = true;
                }
            });
        }
    });
    return rst;
});
//# sourceMappingURL=values-of-key.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/values-of-key.js
// module id = 1160
// module chunks = 37